import { indentUnit } from '@codemirror/language';
import { python } from '@codemirror/lang-python';
import { PYTHON_INDENT } from '@shared/constants/code';

export const getDefaultPythonCodeExtensions = () => [
  python().language,
  indentUnit.of(PYTHON_INDENT)
];
